angular.module('impactx.approval').controller('ApprovalDetailStopOrDenyDialogCtrl', [
    '$scope',
    '$mdDialog',
    'title',
    'doneItems',
    'toDoItems',
    'deniedItems',
    'message',
    'approvalComments',
    'themeFactory',
    'TranslationService',
    'trns',
    ApprovalDetailStopOrDenyDialogCtrl]);

function ApprovalDetailStopOrDenyDialogCtrl($scope, $mdDialog, title, doneItems, toDoItems, deniedItems, message, approvalComments, themeFactory, TranslationService, trns) {
    var self = this;

    $scope.doneItems = doneItems;
    $scope.toDoItems = toDoItems;
    $scope.deniedItems = deniedItems;
    $scope.title = title;
    $scope.message = message;
    $scope.approvalComments = approvalComments;
    $scope.theme = themeFactory.getTheme();
    $scope.trns = {};
    $scope.trns.abort = TranslationService.get('abort');
    $scope.trns.save = TranslationService.get('save');
    angular.merge($scope.trns, trns);

    $scope.newComment = "";

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.newComment);
    };
}